import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}
  async removeItem(key: string) {
    await Preferences.remove({ key: key });
  }

  async clear() {
    await Preferences.clear();
  }

  async setStorage(key: string, object: any) {
    await Preferences.set({
      key: key,
      value: JSON.stringify(object),
    });
  }

  async getStorage<T>(key: string): Promise<T> {
    const { value } = await Preferences.get({ key: key });

    if (value !== 'undefined') {
      return JSON.parse(value || '{}') as T;
    } else {
      return {} as T;
    }
  }
  
  setLang(val: string): Promise<any> {
    return this.setStorage('lang', val);
  }

  getLang(): Promise<any> {
    return this.getStorage('lang');
  }
}
